/*
 *Bushido HTML5 E-Commerce Template v1.2
 *Copyright 2014 8Guild.com
 *All scripts for Bushido HTML5 E-Commerce Template
 */

/*jslint browser: true */
/*jslint white: true */


(function ($) {

    'use strict';

// Helpers

    // Test in an object is an instance of jQuery or Zepto.
    function isInstance(a) {
        return a instanceof $ || ($.zepto && $.zepto.isZ(a));
    }


// Link types

    function fromPrefix(target, method) {

        // If target is a string, a new hidden input will be created.
        if (typeof target === 'string' && target.indexOf('-inline-') === 0) {

            // By default, use the 'html' method.
            this.method = method || 'html';

            // Use jQuery to create the element
            this.target = this.el = $(target.replace('-inline-', '') || '<div/>');

            return true;
        }
    }

    function fromString(target) {

        // If the string doesn't begin with '-', which is reserved, add a new hidden input.
        if (typeof target === 'string' && target.indexOf('-') !== 0) {

            this.method = 'val';

            var element = document.createElement('input');
            element.name = target;
            element.type = 'hidden';
            this.target = this.el = $(element);

            return true;
        }
    }

    function fromFunction(target) {

        // The target can also be a function, which will be called.
        if (typeof target === 'function') {
            this.target = false;
            this.method = target;

            return true;
        }
    }

    function fromInstance(target, method) {

        if (isInstance(target) && !method) {

            // If a jQuery/Zepto input element is provided, but no method is set,
            // the element can assume it needs to respond to 'change'...
            if (target.is('input, select, textarea')) {

                // Default to .val if this is an input element.
                this.method = 'val';

                // Fire the API changehandler when the target changes.
                this.target = target.on('change.liblink', this.changeHandler);

            } else {

                this.target = target;

                // If no method is set, and we are not auto-binding an input, default to 'html'.
                this.method = 'html';
            }

            return true;
        }
    }

    function fromInstanceMethod(target, method) {

        // The method must exist on the element.
        if (isInstance(target) &&
            (typeof method === 'function' ||
                (typeof method === 'string' && target[method]))
        ) {
            this.method = method;
            this.target = target;

            return true;
        }
    }

    var
        /** @const */
        creationFunctions = [fromPrefix, fromString, fromFunction, fromInstance, fromInstanceMethod];


// Link Instance

    /** @constructor */
    function Link(target, method, format) {

        var that = this, valid = false;

        // Forward calls within scope.
        this.changeHandler = function (changeEvent) {
            var decodedValue = that.formatInstance.from($(this).val());

            // If the value is invalid, stop this event, as well as it's propagation.
            if (decodedValue === false || isNaN(decodedValue)) {

                // Reset the value.
                $(this).val(that.lastSetValue);
                return false;
            }

            that.changeHandlerMethod.call('', changeEvent, decodedValue);
        };

        // See if this Link needs individual targets based on its usage.
        // If so, return the element that needs to be copied by the
        // implementing interface.
        // Default the element to false.
        this.el = false;

        // Store the formatter, or use the default.
        this.formatInstance = format;

        // Try all Link types.
        /*jslint unparam: true*/
        $.each(creationFunctions, function (i, fn) {
            valid = fn.call(that, target, method);
            return !valid;
        });
        /*jslint unparam: false*/

        // Nothing matched, throw error.
        if (!valid) {
            throw new RangeError("(Link) Invalid Link.");
        }
    }

    // Provides external items with the object value.
    Link.prototype.set = function (value) {

        // Ignore the value, so only the passed-on arguments remain.
        var args = Array.prototype.slice.call(arguments),
            additionalArgs = args.slice(1);

        // Store some values. The actual, numerical value,
        // the formatted value and the parameters for use in 'resetValue'.
        // Slice additionalArgs to break the relation.
        this.lastSetValue = this.formatInstance.to(value);

        // Prepend the value to the function arguments.
        additionalArgs.unshift(
            this.lastSetValue
        );

        // When target is undefined, the target was a function.
        // In that case, provided the object as the calling scope.
        // Branch between writing to a function or an object.
        (typeof this.method === 'function' ?
            this.method :
            this.target[this.method]).apply(this.target, additionalArgs);
    };


// Developer API

    /** @constructor */
    function LinkAPI(origin) {
        this.items = [];
        this.elements = [];
        this.origin = origin;
    }

    LinkAPI.prototype.push = function (item, element) {
        this.items.push(item);

        // Prevent 'false' elements
        if (element) {
            this.elements.push(element);
        }
    };

    LinkAPI.prototype.reconfirm = function (flag) {
        var i;
        for (i = 0; i < this.elements.length; i += 1) {
            this.origin.LinkConfirm(flag, this.elements[i]);
        }
    };

    LinkAPI.prototype.remove = function (flag) {
        var i;
        for (i = 0; i < this.items.length; i += 1) {
            this.items[i].target.off('.liblink');
        }
        for (i = 0; i < this.elements.length; i += 1) {
            this.elements[i].remove();
        }
    };

    LinkAPI.prototype.change = function (value) {

        if (this.origin.LinkIsEmitting) {
            return false;
        }

        this.origin.LinkIsEmitting = true;

        var args = Array.prototype.slice.call(arguments, 1), i;
        args.unshift(value);

        // Write values to serialization Links.
        // Convert the value to the correct relative representation.
        for (i = 0; i < this.items.length; i += 1) {
            this.items[i].set.apply(this.items[i], args);
        }

        this.origin.LinkIsEmitting = false;
    };


// jQuery plugin

    function binder(flag, target, method, format) {

        if (flag === 0) {
            flag = this.LinkDefaultFlag;
        }

        // Create a list of API's (if it didn't exist yet);
        if (!this.linkAPI) {
            this.linkAPI = {};
        }

        // Add an API point.
        if (!this.linkAPI[flag]) {
            this.linkAPI[flag] = new LinkAPI(this);
        }

        var linkInstance = new Link(target, method, format || this.LinkDefaultFormatter);

        // Default the calling scope to the linked object.
        if (!linkInstance.target) {
            linkInstance.target = $(this);
        }

        // If the Link requires creation of a new element,
        // Pass the element and request confirmation to get the changehandler.
        // Set the method to be called when a Link changes.
        linkInstance.changeHandlerMethod = this.LinkConfirm(flag, linkInstance.el);

        // Store the linkInstance in the flagged list.
        this.linkAPI[flag].push(linkInstance, linkInstance.el);

        // Now that Link have been connected, request an update.
        this.LinkUpdate(flag);
    }

    /** @export */
    $.fn.Link = function (flag) {

        var that = this;

        // Delete all linkAPI
        if (flag === false) {

            return that.each(function () {

                // .Link(false) can be called on elements without Links.
                // When that happens, the objects can't be looped.
                if (!this.linkAPI) {
                    return;
                }

                $.map(this.linkAPI, function (api) {
                    api.remove();
                });

                delete this.linkAPI;
            });
        }

        if (flag === undefined) {

            flag = 0;

        } else if (typeof flag !== 'string') {

            throw new Error("Flag must be string.");
        }

        return {
            to: function (a, b, c) {
                return that.each(function () {
                    binder.call(this, flag, a, b, c);
                });
            }
        };
    };

}(window.jQuery || window.Zepto));

/*Document Ready*////////////////////////////////////////////////////////////////////////////////////////////////////////////////
$(document).ready(function (e) {

    /*Global Variables
    *******************************************/
    var $searchBtn = $('.search-btn');
    var $closeSearch = $('.close-search');
    var $subscrForm = $('.subscr-form');
    var $nextField = $('.subscr-next');
    var $loginBtn = $('.login-btn');
    var $loginForm = $('.modal .login-form');
    var $loginForm2 = $('.checkout .login-form');
    var $loginForm3 = $('.log-reg .login-form');
    var $regForm = $('.registr-form');
    var $checkoutForm = $('#checkout-form');
    var $orderTrackForm = $('.order-tracking');
    var $personalInfo = $('.personal-info');
    var $cartTotal1 = $('.js-minicart-total');
    var $header = $('header');
    var $headerOffsetTop = $header.data('offset-top');
    var $headerStuck = $header.data('stuck');
    var $menuToggle = $('.menu-toggle');
    var $menu = $('.menu');
    var $submenuToggle = $('.menu .has-submenu > a > i');
    var $submenu = $('.menu .submenu');
    var $featureTab = $('.feature-tabs .tab');
    var $featureTabPane = $('.feature-tabs .tabs-pane');
    var $brandCarousel = $('.brand-carousel .inner');
    var $catCarousel = $('.cat-carousel .inner');
    var $shareBtn1 = $('.tile .share-btn i');
    var $offersTabs = $('.offer-tabs .tab-navs a');
    var $offersTabsCarousel = $('.offer-tabs .tab-navs');
    var $sortToggle = $('.sorting a');
    var $activePage = $('.pagination li.active a');
    var $subcatToggle = $('.filter-section .categories .has-subcategory > a');
    var $filterToggle = $('.filter-toggle');
    var $scrollTopBtn = $('#scrollTop-btn');
    var $qcfBtn = $('#qcf-btn');
    var $addToCartBtn = $('.js-add-item-to-cart');
    var addedToCartMessage = $('.cart-message');
    var $promoLabels = $('.promo-labels div');
    var $panelToggle = $('.panel-toggle');
    var $accordionToggle = $('.accordion .panel-heading a');

    /*Login Forms
    *******************************************/
    $loginForm.validate();
    $loginForm2.validate();
    $loginForm3.validate();
    $('#log-password').focus(function () {
        $(this).attr('type', 'password');
    });

    /*Registration Form Validation
    *******************************************/
    $regForm.validate();

    /*Checkout Form Validation
    *******************************************/
    $checkoutForm.validate({
        rules: {
            co_postcode: {
                required: true,
                number: true
            },
            co_phone: {
                required: true,
                number: true
            }
        }
    });

    /*Order Tracking Form Validation
    *******************************************/
    $orderTrackForm.validate({
        rules: {
            ot_id: {
                required: true,
                number: true
            },
            ot_email: {
                required: true,
                email: true
            }
        }
    });

    /*Account Personal Info Form
    *******************************************/
    $personalInfo.validate({
        rules: {
            api_phone: {
                required: true,
                number: true
            },
            api_email: {
                required: true,
                email: true
            }
        }
    });

    /*Shopping Cart Dropdown
    *******************************************/
    //Deleting Items
    $(document).on('click', '.js-minicart-delete', function () {
        var $target = $(this).parent().parent();
        var $positions = $('.js-minicart-item');
        var $positionQty = $('.js-basket-total-amount').text();
        $target.hide(300, function () {
            $.when($target.remove()).then(function () {
                //$positionQty = $positionQty - 1;
                updateHeaderBasketTotal($positionQty);

                if ($positions.length === 1) {
                    $('.js-minicart-body').html('<h3>Cart is empty!</h3>');
                    updateHeaderBasketTotal('Empty', '0.00', '0.00');
                    $('.js-minicart-footer-total').text('£0.00');
                }
            });
        });
    });

    /*Shopping Cart Page
    *******************************************/
    //Deleting Items
    $(document).on('click', '.shopping-cart .delete i', function () {
        var $target = $(this).parent().parent();
        var $positions = $('.shopping-cart .item');
        $target.hide(300, function () {
            $.when($target.remove()).then(function () {
                if ($positions.length === 1) {
                    //$('.shopping-cart .items-list').remove();
                    //$('.shopping-cart .title').text('Shopping cart is empty!');
                }
            });
        });
    });

    /*Wishlist Deleting Items
    *******************************************/
    $(document).on('click', '.wishlist .delete i', function () {
        var $target = $(this).parent().parent();
        $target.hide(300, function () {
            $.when($target.remove()).then(function () {
                if ($positions.length === 1) {
                    $('.wishlist .items-list').remove();
                    $('.wishlist .title').text('Wishlist is empty!');
                }
            });
        });
    });

    /*Catalog 3-rd Level Submenu positioning
    *******************************************/
    $('.catalog .submenu .has-submenu').hover(function () {
        var $offseTop = $(this).position().top;
        $(this).find('.sub-submenu').height($(this).parent().find(".offer").height() - 12);
        //$(this).find('.sub-submenu').height($('.catalog .submenu .offer').height()-12);
        $('.catalog .submenu .offer .col-1 p').hide();
        $(this).find('.sub-submenu').css({top: -$offseTop + 12 + "px"}).show();
    }, function () {
        $(this).find('.sub-submenu').hide();
        $('.catalog .submenu .offer .col-1 p').show();
    });

    /*Small Header slide down on scroll
    *******************************************/
    if ($(window).width() >= 500) {
        $(window).on('scroll', function () {
            if ($(window).scrollTop() > $headerOffsetTop) {
                $header.addClass('small-header');
            } else {
                $header.removeClass('small-header');
            }
            if ($(window).scrollTop() > $headerStuck) {
                $header.addClass('stuck');
            } else {
                $header.removeClass('stuck');
            }
        });
    }

    /*Subscription Form Widget
    *******************************************/
    $subscrForm.validate();
    $nextField.click(function (e) {
        var $target = $(this).parent();
        if ($subscrForm.valid() === true) {
            $target.hide('drop', 300, function () {
                $target.next().show('drop', 300);
            });
        }
        e.preventDefault();
    });


    /*Parallax Backgrounds
    *******************************************/
    $(window).on('load', function () {
        /*Checking if it's touch device we disable parallax feature due to inconsistency*/
        /*if (Modernizr.touch) {
            $('body').removeClass('parallax');
        }*/
        /*$('.parallax').stellar({
            horizontalScrolling: false,
            responsive: true
        });*/
    });

    /*Features Tabs
    *******************************************/
    $featureTab.on('mouseover', function () {
        $featureTab.removeClass('active');
        $(this).addClass('active');
        var $curTab = $(this).attr('data-tab');
        $featureTabPane.removeClass('current');
        $('.feature-tabs .tabs-pane' + $curTab).addClass('current');
    });

    /*Enable Touch / swipe events for carousel
    *******************************************/
    /*$(".carousel-inner").swipe({
        //Generic swipe handler for all directions
        swipeRight: function (event, direction, distance, duration, fingerCount) {
            $(this).parent().carousel('prev');
        },
        swipeLeft: function () {
            $(this).parent().carousel('next');
        },
        //Default is 75px, set to 0 for demo so any distance triggers swipe
        threshold: 0
    });*/

    /*Initializing Gallery Plugin
    *******************************************/
    /*    gallery.init();
        $('.gallery-grid').lightGallery({
            speed: 400
        });*/

    /*Initializing Brands Carousel Plugin
    *******************************************/
    /*$brandCarousel.owlCarousel({
        // Define custom and unlimited items depending from the width
        // If this option is set, itemsDeskop, itemsDesktopSmall, itemsTablet, itemsMobile etc. are disabled
        // For better preview, order the arrays by screen size, but it's not mandatory
        // Don't forget to include the lowest available screen size, otherwise it will take the default one for screens lower than lowest available.
        // In the example there is dimension with 0 with which cover screens between 0 and 450px
        itemsCustom: [
            [0, 1],
            [340, 2],
            [580, 3],
            [991, 4],
            [1200, 5]
        ],
        navigation: true,
        theme: "",
        navigationText: ["", ""]
    });*/

    /*$catCarousel.owlCarousel({
        itemsCustom: [
            [0, 1],
            [340, 1],
            [580, 2],
            [991, 4],
            [1200, 4]
        ],
        navigation: true,
        theme: "",
        navigationText: ["", ""]
    });*/

    /*Hero Slider
    *******************************************/
    if ($('#hero-slider').length > 0) {
        var heroSlider = new MasterSlider();
        heroSlider.control('arrows');
        heroSlider.control('bullets');
        heroSlider.setup('hero-slider', {
            width: 1140,
            height: 455,
            space: 0,
            speed: 18,
            autoplay: true,
            loop: true,
            layout: 'fullwidth',
            preload: 'all',
            view: 'basic',
            instantStartLayers: true
        });
    }

    /*Hero Fullscreen Slider
    *******************************************/
    if ($('#fullscreen-slider').length > 0) {
        var fullscreenSlider = new MasterSlider();
        fullscreenSlider.control('arrows');
        fullscreenSlider.control('bullets');
        fullscreenSlider.setup('fullscreen-slider', {
            width: 1140,
            height: 455,
            space: 0,
            speed: 18,
            autoplay: true,
            loop: true,
            layout: 'fullscreen',
            fullscreenMargin: 144,
            preload: 'all',
            view: 'mask',
            instantStartLayers: true
        });
    }

    /*Category Slider
    *******************************************/
    if ($('#cat-slider').length > 0) {
        var categorySlider = new MasterSlider();
        categorySlider.control('thumblist', {
            autohide: false,
            dir: 'h',
            type: 'tabs',
            width: 164,
            height: 280,
            align: 'bottom',
            space: 30,
            margin: 13,
            hideUnder: 400
        });
        categorySlider.setup('cat-slider', {
            width: 1050,
            height: 550,
            space: 0,
            speed: 25,
            layout: 'fullwidth',
            preload: 'all',
            view: 'basic',
            instantStartLayers: true
        });
    }

    /*Offers Tabs
    *******************************************/
    $offersTabs.click(function () {
        $offersTabs.removeClass('active');
        $(this).addClass('active');
    });

    /*$offersTabsCarousel.owlCarousel({
        itemsCustom: [
            [0, 1],
            [420, 2],
            [880, 3],
            [1200, 3]
        ],
        navigation: false,
        theme: ""
    });*/

    /*Catalog Sorting Toggles
    *******************************************/
    $sortToggle.click(function (e) {
        $(this).toggleClass('sorted');
        e.preventDefault();
    });

    /*Disabling link on active page
    *******************************************/
    $activePage.click(function (e) {
        e.preventDefault();
    });

    /*Catalog Filters
    *******************************************/
    //Price Slider Range
    var $minVal = parseInt($('#minVal').attr('data-min-val'));
    var $maxVal = parseInt($('#maxVal').attr('data-max-val'));
    var $startMin = parseInt($('#minVal').val());
    var $startMax = parseInt($('#maxVal').val());
    if ($('#price-range').length > 0) {
        $('#price-range').noUiSlider({
            range: {
                'min': $minVal,
                'max': $maxVal
            },
            start: [$startMin, $startMax],
            connect: true,
            serialization: {
                lower: [
                    $.Link({
                        target: $('#minVal'),
                        format: {
                            decimals: 0
                        }
                    })
                ],
                upper: [
                    $.Link({
                        target: $('#maxVal'),
                        format: {
                            decimals: 0
                        }
                    })
                ]
            }
        });
    }

    //Clear price filters
    $('#clearPrice').click(function () {
        $('#price-range').val([$startMin, $startMax], {set: true});
    });

    //Clear Checkbox filters
    /*$('.clearChecks').click(function () {
        $(this).parent().find('.icheckbox').removeClass('checked');
    });*/

    //Categories accordion
    $subcatToggle.click(function (e) {
        $(this).parent().toggleClass('opened');
        $(this).parent().find('.subcategory').toggleClass('open');
        e.preventDefault();
    });

    //Filter Toggle / Showing Filters in Modal
    $filterToggle.click(function () {
        $('.shop-filters').appendTo($('#filterModal .modal-body'));
        $('#filterModal .modal-body .shop-filters').css('display', 'block');
    });

    $('#filterModal').on('hide.bs.modal', function () {
        $('.shop-filters').appendTo('.filters-mobile');
    });

    $(window).resize(function () {
        if ($(window).width() > 768) {
            $('#filterModal').modal('hide');
        }
    });

    /*Catalog Single
    *******************************************/
    //Product Gallery
    if ($('#prod-gal').length > 0) {
        var categorySlider = new MasterSlider();
        categorySlider.control('thumblist', {
            autohide: false,
            dir: 'h',
            align: 'bottom',
            width: 137,
            height: 130,
            margin: 15,
            space: 0,
            hideUnder: 400
        });
        categorySlider.setup('prod-gal', {
            width: 550,
            height: 484,
            speed: 25,
            preload: 2,
            loop: true,
            view: 'fade',
            autoHeight: true
        });
    }

    //Add(+/-) Button Number Incrementers
    $(".incr-btn").on("click", function (e) {
        var $button = $(this);
        var oldValue = $button.parent().find("input").val();
        if ($button.text() == "+") {
            var newVal = parseFloat(oldValue) + 1;
        } else {
            // Don't allow decrementing below 1
            if (oldValue > 1) {
                var newVal = parseFloat(oldValue) - 1;
            } else {
                newVal = 1;
            }
        }
        $button.parent().find("input").val(newVal);
        e.preventDefault();
    });

    /*Added To Cart Message + Action (For Demo Purpose)
    **************************************************/
    $addToCartBtn.click(function () {
        console.log('addToCart()');

        CartMessage(this);

        var itemName = $('.js-product-name').text();

        var itemPrice = $('.js-product-price:visible').text();
        itemPrice = parseFloat(itemPrice.replace(/[^\d.-]/g, ''))

        var itemQnty = $(this).parent().find('.js-add-quantity').val();

        var cartTotalItems = $('.js-basket-total-amount').text();

        cartTotalItems = cartTotalItems.replace(/[^\d.-]/g, '');
        if (cartTotalItems == '') {
            cartTotalItems = 0;
        }

        cartTotalItems = parseFloat(cartTotalItems);

        cartTotalItems = cartTotalItems + itemPrice;
        cartTotalItems = Math.round((cartTotalItems + Number.EPSILON) * 100) / 100;

        $('.cart-dropdown table').append(
            '<tr class="item"><td><div class="delete"></div><a href="#">' + itemName +
            '<td><input type="text" value="' + itemQnty +
            '"></td><td class="price">' + itemPrice + '</td>'
        );

        updateHeaderBasketTotal(formatter.format(cartTotalItems));

        var stockCode = $(this).closest('.js-product-page').find('.js-product-stock-code').first().text();

        $.post("/ajax/AddToBasket/" + stockCode + "/" + itemQnty, {}, function (data) {
            UpdateBasket(data);
        });
    });

    /*Promo Labels Popovers
    *******************************************/
    $promoLabels.popover({
        placement: 'top',
        trigger: 'hover'
    });

    /*Special Offer Autoheight
    *******************************************/
    $(window).load(function () {
        var tileH = $('.special-offer .tile').height();
        $('.special-offer .offer').css('height', tileH);
    });
    $(window).resize(function () {
        var tileH = $('.special-offer .tile').height();
        $('.special-offer .offer').css('height', tileH);
    });

    /*Expandable Panels
    *******************************************/
    $panelToggle.click(function (e) {
        $(this).toggleClass('active');
        var $target = $(this).attr('href');
        $($target).toggleClass('expanded');
        e.preventDefault();
    });

    /*Accordion Widget
    *******************************************/
    $accordionToggle.click(function () {
        $accordionToggle.parent().removeClass('active');
        $(this).parent().addClass('active');
    });

    /*Sticky Buttons
    *******************************************/
    //Scroll to Top Button
    $(window).scroll(function () {
        if ($(this).scrollTop() > 500) {
            $scrollTopBtn.parent().addClass('scrolled');
        } else {
            $scrollTopBtn.parent().removeClass('scrolled');
        }
    });
    $scrollTopBtn.click(function () {
        $('html, body').animate({scrollTop: 0}, {duration: 700, easing: "easeOutExpo"});
    });

    //Quick Contact Form
    $qcfBtn.click(function () {
        $(this).toggleClass('active');
        $(this).parent().find('.quick-contact').toggleClass('visible');
    });
    $('.page-content, .subscr-widget, footer, header').click(function () {
        $qcfBtn.removeClass('active');
        $('.quick-contact').removeClass('visible');
    });


});/*Document Ready End*//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/*Gallery Filtering and Responsiveness Function
*******************************************/
/*var gallery = (function ($) {
    'use strict';

    var $grid = $('.gallery-grid'),
        $filterOptions = $('.filters'),
        $sizer = $grid.find('.shuffle__sizer'),

        init = function () {

            // None of these need to be executed synchronously
            setTimeout(function () {
                listen();
                setupFilters();
            }, 100);

            $grid.on('loading.shuffle done.shuffle shrink.shuffle shrunk.shuffle filter.shuffle filtered.shuffle sorted.shuffle layout.shuffle', function (evt, shuffle) {
                // Make sure the browser has a console
                if (window.console && window.console.log && typeof window.console.log === 'function') {
                    console.log('Shuffle:', evt.type);
                }
            });

            // instantiate the plugin
            $grid.shuffle({
                itemSelector: '.gallery-item',
                sizer: $sizer
            });
        },

        // Set up button clicks
        setupFilters = function () {
            var $btns = $filterOptions.children();
            $btns.on('click', function (e) {
                var $this = $(this),
                    isActive = $this.hasClass('active'),
                    group = $this.data('group');
                $('.filters .active').removeClass('active');
                $this.addClass('active');

                // Filter elements
                $grid.shuffle('shuffle', group);
                e.preventDefault();
            });

            $btns = null;
        },

        listen = function () {
            var debouncedLayout = $.throttle(300, function () {
                $grid.shuffle('update');
            });

            // Get all images inside shuffle
            $grid.find('img').each(function () {
                var proxyImage;

                // Image already loaded
                if (this.complete && this.naturalWidth !== undefined) {
                    return;
                }

                // If none of the checks above matched, simulate loading on detached element.
                proxyImage = new Image();
                $(proxyImage).on('load', function () {
                    $(this).off('load');
                    debouncedLayout();
                });

                proxyImage.src = this.src;
            });

            // Because this method doesn't seem to be perfect.
            setTimeout(function () {
                debouncedLayout();
            }, 500);
        };

    return {
        init: init
    };
}(jQuery));*/

/*
 * Bootstrap Cookie Alert by Wruczek
 * https://github.com/Wruczek/Bootstrap-Cookie-Alert
 * Released under MIT license
 */
// (function () {
//     "use strict";
//
//     var cookieAlert = document.querySelector(".cookiealert");
//     var acceptCookies = document.querySelector(".acceptcookies");
//
//     if (!cookieAlert) {
//         return;
//     }
//
//     cookieAlert.offsetHeight; // Force browser to trigger reflow (https://stackoverflow.com/a/39451131)
//
//     // Show the alert if we cant find the "acceptCookies" cookie
//     if (!getCookie("acceptCookies")) {
//         cookieAlert.classList.add("show");
//     }
//
//     // When clicking on the agree button, create a 1 year
//     // cookie to remember user's choice and close the banner
//     acceptCookies.addEventListener("click", function () {
//         setCookie("acceptCookies", true, 365);
//         cookieAlert.classList.remove("show");
//     });
//
//     // Cookie functions from w3schools
//     function setCookie(cname, cvalue, exdays) {
//         var d = new Date();
//         d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
//         var expires = "expires=" + d.toUTCString();
//         document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
//     }
//
//     function getCookie(cname) {
//         var name = cname + "=";
//         var decodedCookie = decodeURIComponent(document.cookie);
//         var ca = decodedCookie.split(';');
//         for (var i = 0; i < ca.length; i++) {
//             var c = ca[i];
//             while (c.charAt(0) === ' ') {
//                 c = c.substring(1);
//             }
//             if (c.indexOf(name) === 0) {
//                 return c.substring(name.length, c.length);
//             }
//         }
//         return "";
//     }
// })();
